/* global axios */
import ApiClient from '../../ApiClient';

// WhatsApp calls of WAHA inboxes. The browser always sends the SDP offer and gets
// WAHA's answer back, from initiate and from accept.
class WahaCallsAPI extends ApiClient {
  constructor() {
    super('waha_calls', { accountScoped: true });
  }

  show(callId) {
    return axios.get(`${this.url}/${callId}`).then(r => r.data);
  }

  // Either conversationId, or contactId + inboxId to let the BE resolve the conversation.
  initiate({ conversationId, contactId, inboxId }, sdpOffer) {
    return axios
      .post(`${this.url}/initiate`, {
        conversation_id: conversationId,
        contact_id: contactId,
        inbox_id: inboxId,
        sdp_offer: sdpOffer,
      })
      .then(r => r.data);
  }

  // Also takes a call transferred to this agent
  accept(callId, sdpOffer) {
    return axios
      .post(`${this.url}/${callId}/accept`, { sdp_offer: sdpOffer })
      .then(r => r.data);
  }

  reject(callId) {
    return axios.post(`${this.url}/${callId}/reject`).then(r => r.data);
  }

  terminate(callId) {
    return axios.post(`${this.url}/${callId}/terminate`).then(r => r.data);
  }

  // Voice calls readiness of the WAHA server and session (inbox settings)
  health(inboxId) {
    return axios
      .get(`${this.url}/health`, { params: { inbox_id: inboxId } })
      .then(r => r.data);
  }

  transfer(callId, agentId) {
    return axios
      .post(`${this.url}/${callId}/transfer`, { agent_id: agentId })
      .then(r => r.data);
  }
}

export default new WahaCallsAPI();
